
export const APP_MODEL_PREFIX = 'app-model';

export const ORGANIZATION_ITEM_NAME = 'organization';
export const ORGANIZATION_ITEM_PREFIX = `@@${ORGANIZATION_ITEM_NAME}`;

export const ORG_PROFILE_ITEM_NAME = 'orgProfile';
export const ORG_PROFILE_ITEM_PREFIX = `@@${ORG_PROFILE_ITEM_NAME}`;

export const PROJECT_ITEM_NAME = 'project';
export const PROJECT_ITEM_PREFIX = `@@${PROJECT_ITEM_NAME}`;

export const ASSET_PROJECT_ITEM_NAME = 'assetProject';
export const ASSET_PROJECT_ITEM_PREFIX = `@@${ASSET_PROJECT_ITEM_NAME}`;

export const ASSET_ITEM_NAME = 'asset';
export const ASSET_ITEM_PREFIX = `@@${ASSET_ITEM_NAME}`;



// WEBPACK FOOTER //
// ./src/js/app/model/redux/state.js